import type { QuestionnaireState } from "../../types";

export const handleSetErrorsAction = (
  state: QuestionnaireState,
  payload: Record<string, string>,
): QuestionnaireState => {
  return {
    ...state,
    errors: payload,
  };
};
